<template>
  <div
    ref="lottieContainer"
    :style="lottieStyle"
  />
</template>

<script lang="ts" setup>
import type { AnimationConfigWithPath, AnimationItem, RendererType } from 'lottie-web'
import * as lottie from 'lottie-web'
import type { StyleValue } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'

import { parseDomSizeValue } from '../../utils/string.utils'

export interface ILottieProps<T extends RendererType = 'svg'> {
  path: string
  width?: number | string
  height?: number | string
  style?: StyleValue
  options?: Omit<AnimationConfigWithPath<T>, 'container'>
}

const props = defineProps<ILottieProps>()
const lottieContainer = ref<Element | null>(null)
const lottieObj = ref<AnimationItem | null>(null)
const emit = defineEmits([ 'onLoad' ])

const lottieStyle = computed(() => {
  if (props.style) return props.style

  return {
    width: props.width ? parseDomSizeValue(props.width) : '100%',
    height: props.height ? parseDomSizeValue(props.height) : '100%',
  }
})

const lottieInit = () =>{
  if (!lottieContainer.value) return
  if (lottieObj.value) lottieObj.value.destroy()

  const options: AnimationConfigWithPath = {
    ...props.options,
    container: lottieContainer.value as Element,
    path: props.path,
  }

  lottieObj.value = lottie.default.loadAnimation(options)
  emit('onLoad', lottieObj)
}

onMounted(() => {
  lottieInit()
})

watch(()=>props.path, ()=>{
  lottieInit()
})
</script>
